module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Laufen_BL-0ea421b321043cf92750fc7e48755ff2.png";